import { InfoIcon } from '@phosphor-icons/react';
import { ChoiceGroup, Tooltip } from '@skupreme/shared/ui';
import { Controller, type Control } from 'react-hook-form';
import { StorageProviderHelpText } from '@utility/constants/strings';
import type { AddProviderValues } from '../../lib/add-provider';

const QUANTITY_TYPES = [
  { value: 'unit', label: 'Unit' },
  { value: 'cartons', label: 'Carton' },
];

export function QuantityTypeField({
  control,
}: {
  control: Control<AddProviderValues>;
}) {
  return (
    <div className="sk:flex sk:flex-col sk:gap-1.5">
      <span className="sk:flex sk:items-center sk:gap-1 sk:text-dense sk:font-medium sk:text-fg-secondary">
        Quantity Type
        <Tooltip content={StorageProviderHelpText.quantityTypeInfo}>
          <InfoIcon size={12} className="sk:text-fg-tertiary" />
        </Tooltip>
      </span>
      <Controller
        control={control}
        name="quantity_type"
        defaultValue="unit"
        render={({ field }) => (
          <ChoiceGroup
            label="Quantity Type"
            options={QUANTITY_TYPES}
            value={field.value ?? 'unit'}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  );
}
